import React from 'react';
import TabContainer from '../../components/TabContainer';
import POSSatisPage from '../pos/POSSatisPage';
import UrunSatisRaporuPage from '../raporlar/UrunSatisRaporuPage';
import MenuMuhendisligiPage from '../menu-muhendisligi/MenuMuhendisligiPage';
import AnalizSonuclariPage from '../menu-muhendisligi/AnalizSonuclariPage';
// 2026-06-29: Sekme geri açıldı. 2026-05-01'de "Reçete > Maliyet Analizi ile
// örtüşüyor" denerek kapatılmıştı; ama satış-fiyatı what-if'i (fiyatı X yaparsam
// aylık kâr etkisi) Maliyet Analizi'nde YOK ve özgün değer. Sayfa tam çalışır
// durumdaydı, yalnızca UI'dan erişilemiyordu (öksüz route).
import FiyatSimulasyonuPage from '../menu-muhendisligi/FiyatSimulasyonuPage';

const SatisAnalizPage = () => {
  const tabs = [
    { id: 'urun-satis-raporu', label: 'Ürün Satış Raporu', icon: '📊', component: <UrunSatisRaporuPage embedded /> },
    { id: 'pos-satis', label: 'POS Satış Verileri', icon: '🧾', component: <POSSatisPage /> },
    { id: 'menu-muhendisligi', label: 'Menü Mühendisliği', icon: '🔬', component: <MenuMuhendisligiPage /> },
    { id: 'analiz-sonuclari', label: 'Analiz Sonuçları', icon: '📈', component: <AnalizSonuclariPage /> },
    { id: 'fiyat-simulasyonu', label: 'Fiyat Simülasyonu', icon: '💰', component: <FiyatSimulasyonuPage /> },
  ];

  return <TabContainer title="Satış & Analiz" tabs={tabs} defaultTab="urun-satis-raporu" />;
};

export default SatisAnalizPage;
